import { createApiHandler } from './handler';

const shippingWeightTiers = {
  apiClient: null,
  path: '/admin/shipping-weight-tiers',

  setClient(apiClient) {
    this.apiClient = apiClient;
    this.initApiHandler();
  },

  initApiHandler() {
    Object.assign(this, createApiHandler(this.apiClient, this.path));
  },
};

export default shippingWeightTiers;
